import { render, staticRenderFns } from "./EntityListTable.vue?vue&type=template&id=2c9f6b20"
import script from "./EntityListTable.vue?vue&type=script&lang=ts"
export * from "./EntityListTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports